<app-traitement-data titre="Durée (min - max)" [sousTitre]="patient!.tableauDeBord?.duree?.date | aLaDateDu"
    statut="info">
    {{ patient!.tableauDeBord?.dureeMin?.value ?? 'Ø' }} - {{ patient!.tableauDeBord?.dureeMax?.value ?? 'Ø' }}
</app-traitement-data>